import axios from './axios'
import {i18n} from "@/i18n";


function getContactUrl(subject) {
    let mailTo = `mailto:support@getpica.com`
    if (subject){
       mailTo = `${mailTo}?subject=${subject}`
    }
    return mailTo
}

const metricB2B = {
    'BOX_CTA': '?utm_source=getpica.com&utm_medium=referral&utm_campaign=box_cta',
    'MENU': '?utm_source=getpica.com&utm_medium=referral&utm_campaign=menu',
    'HEADER': '?utm_source=getpica.com&utm_medium=referral&utm_campaign=header',
    'PHOTOBOOK': '?utm_source=getpica.com&utm_medium=referral&utm_campaign=photobook',
}

function getB2BUrl(metric= '', slug) {
    let locale = i18n.locale
    return `https://business.getpica.com${locale === 'it' ? '/it' : ''}${slug ? `/${slug}` : ''}${metric}`
}

function policyUrl() {
      let currentLanguage = i18n.locale
      const unavailableLanguages = ['pl', 'pt']
      if (unavailableLanguages.includes(currentLanguage)) currentLanguage = 'en'
      return {
        terms: `${process.env.VUE_APP_PICA_POLICY_BASE_URL}/${currentLanguage}/termini-condizioni-vendita/`,
        privacy: `${process.env.VUE_APP_PICA_POLICY_BASE_URL}/${currentLanguage}/privacy-policy-pica/`,
      }

}

const APP_STORES_URL = {
    appStore: 'https://apps.apple.com/app/pica/id1173349570',
    playStore: 'https://play.google.com/store/apps/details?id=com.weareorigami.pica',
    huaweiStore: 'https://appgallery.huawei.com/app/C101333805',
}
const MOBILE_OS = {
    unknown: 'unknown',
    android: 'android',
    ios: 'ios',
    windowsPhone: 'windows-phone'
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
function getMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return MOBILE_OS.windowsPhone
    }

    if (/android/i.test(userAgent)) {
        return MOBILE_OS.android
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return MOBILE_OS.ios
    }

    return MOBILE_OS.unknown;
}

export { axios, getContactUrl, getB2BUrl, getMobileOS, MOBILE_OS, APP_STORES_URL, metricB2B, policyUrl }